// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Djibouti from '../_raw/flag/icon_flag_djibouti.png';

export default () => <img src={Djibouti} alt="Djibouti" />;
